/**
 * Queue tab — lucide icon mappings for flow layers and lifecycle states. Kept
 * apart from queue-status.util so the tone/label helpers stay lucide-free.
 * For Media Devoted | Created By Ciro Autiero
 */

import {
  Activity,
  Clock,
  Hourglass,
  LayoutPanelTop,
  Layers,
  Route,
  Tag,
  XCircle,
  type LucideIcon,
} from 'lucide-react';
import type { FlowLayer, QueueElementState } from '@trafficpulse/shared';

import { type QueueLayerFilter } from './queue-filters';

const LAYER_ICONS: Record<FlowLayer, LucideIcon> = {
  paths: Route,
  landers: LayoutPanelTop,
  offers: Tag,
};

/** Distinct lucide glyph per flow layer (row layer cell). */
export function layerIcon(layer: FlowLayer): LucideIcon {
  return LAYER_ICONS[layer];
}

/** Layer-filter pill glyph — 'all' shows the neutral Layers icon. */
export function layerFilterIcon(value: QueueLayerFilter): LucideIcon {
  return value === 'all' ? Layers : layerIcon(value);
}

const STATE_ICONS: Record<QueueElementState, LucideIcon> = {
  waiting: Hourglass,
  queued: Clock,
  testing: Activity,
  removed: XCircle,
};

/** Lucide glyph per lifecycle state (status badge + segment pill). */
export function stateIcon(state: QueueElementState): LucideIcon {
  return STATE_ICONS[state];
}
